// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d6e77e61","132":"92ac60ad","787":"94f89fff"}[chunkId] + ".chunk.js";
};